import CardCommon from '@op/components/CardCommon';
import { cardIcon, tableIcon } from '@op/constants/chart';
import React, { useEffect, useState } from 'react';
import FigureCard from '../components/FigureCard/index';
import SvgIcon from '@/pages/home/components/SvgIcon';
import './index.scss';
import useLanguage from '@op/hooks/useLanguage';
import SortBySelect from '@op/components/FilterBoxCommon/filters/single-select-factory';
import TableCommonHook from '@op/components/TableCommonHook';
import { useTrendingColumn } from '@op/components/TableCommonHook/hooks/useTrendingColumn';
import { useTrendingRequest } from '../hooks/useTrendingRequest';
import { useHistory } from 'umi';
import {
  useDrilldownParams,
  EDrilldownMode,
} from '@op/hooks/useDrilldownParams';
import { SortBy } from 'tea-component/lib/table/addons';
import { useDownloadParams } from '@op/hooks/useDownloadParams';
import { buriedBtnPoint } from '@op/operationLog/buriedPoint';
import { goToFeedsReviewsDetail } from '@op/utils/url';
import { useTrendingLoading } from '@op/models/loading/useTrendingLoading';

const sortByOptions = [
  { value: 'view', text: 'Views' },
  { value: 'engagement', text: 'Engagement' },
  { value: 'follower_number', text: 'Followers' },
  { value: 'tweets_reply', text: 'Comments' },
  { value: 'comment_time', text: 'Date' },
];

const sortColumns = sortByOptions.map((val) => val.value);
const extraFilter = {
  review_types: ['posts_video', 'stream_titles'],
  media_types: ['video', 'live'],
};

export default function TrendingVideo({
  filter,
  language,
  gameInfo,
  wholeGameInfo,
  titleOnClickPath,
  jumpType,
  initialSortBy,
  initialIsActive = false,
  initialView = 'card',
  videoStateOuterRef,
}: any) {
  const { formatMessage } = useLanguage();
  const [isActive, setIsActive] = useState(initialIsActive);
  const [view, setView] = useState(initialView);
  const [sortBy, setSortBy] = useState<SortBy<any>>(
    initialSortBy || { by: 'engagement', order: 'desc' },
  );

  // 同步子组件状态到父级 ref，用于离开页面时保存
  useEffect(() => {
    if (videoStateOuterRef) {
      videoStateOuterRef.current = { sortBy, isActive, view };
    }
  }, [sortBy, isActive, view, videoStateOuterRef]);
  const handleClick = () => {
    buriedBtnPoint('TPTV_ClickMore');
    setIsActive(!isActive);
  };

  const { data, loading } = useTrendingRequest({
    filter,
    sortBy,
    extraFilter,
    type: 'video',
  });

  // 首次加载完成时通知父组件
  useTrendingLoading('trendingVideo', loading ?? false);

  const { columns } = useTrendingColumn({
    language,
    wholeGameInfo,
    keys: ['video', 'authorCountry', 'view', 'engagement', 'subscribe', 'tweetsReply'],
    statistics: data?.statistics,
    logBtnId: 'TrendingVideos',
    gameInfo,
  });

  const history = useHistory();
  const { goPage } = useDrilldownParams({ jumpType });
  const navigatePage = (path?: string) => {
    const gameid = gameInfo?.edition_unified_id;
    return goPage({
      path: path
        ? `${path}${gameid ? `?gameid=${gameid}` : ''}`
        : `/opinion/Community/Video?${gameid ? `gameid=${gameid}&` : ''}by=${sortBy.by
        }&order=${sortBy.order}`,
      filter,
      mode: EDrilldownMode.Local,
    });
  };

  const hasMore = (data?.total || 0) > 4;

  const { downloadLegacy, downloading } = useDownloadParams();

  return (
    <CardCommon
      title={formatMessage({ id: 'Trending Videos' })}
      operations={[cardIcon, tableIcon]}
      hasTitleArrow
      loading={loading}
      className="card--trend-video"
      handleOperationsOnClick={(item) => {
        setView(item?.symbol || 'card');
      }}
      loadingHeight={300}
      emptyHeight={300}
      empty={data?.list?.length === 0}
      hasDownload={data?.list?.length > 0}
      handleTitleOnClick={() =>
        titleOnClickPath ? navigatePage(titleOnClickPath) : navigatePage()
      }
      handleDownloadOnClick={async () => {
        const downloadLimit = 50;
        // if (!data?.total) return;
        const params = {
          page: 1,
          page_size: downloadLimit,
          sort_item: sortBy.by,
          sort_model: sortBy.order,
          noChangePageSize: true,
        };
        const downLoadParams = {
          ...filter,
          ...params,
        };
        const gameName = wholeGameInfo?.entity_name || '';
        const fileName = `${gameName} Trending Video - DataBrain Opinions`;
        await downloadLegacy({
          total: downloadLimit,
          limit: downloadLimit,
          fileName,
          params: downLoadParams,
          downloadFunc: 'getOpinionVideoComments',
          sheetName: 'TrendingVideo',
        });
      }}
      downloadLoading={downloading}
      logBtnId={'TrendingVideos'}
    >
      {/* 点击更多切换 active */}
      <div
        className={`trend-video-list-wrapper ${isActive || !hasMore ? 'active' : ''
          }`}
      >
        {view === 'card' ? (
          <>
            <SortBySelect
              defaultParams={{
                options: sortByOptions,
                btnTextPrefix: formatMessage({ id: 'Sort By' }),
              }}
              defaultValue={sortBy.by}
              onChange={(_key: any, val: string) => {
                setSortBy({ by: val, order: 'desc' });
                buriedBtnPoint('TPTV_Sort', { by: val, order: 'desc' });
              }}
            />
            <div className="trend-video-list">
              {data?.list?.length > 0 &&
                data?.list?.map((item: any, index: number) => (
                  <div className="trend-video-item" key={index}>
                    <FigureCard
                      size="small"
                      item={item}
                      wholeGameInfo={wholeGameInfo}
                      language={language}
                      navigatePage={(e: any) => {
                        buriedBtnPoint('TPTV_ClickCard', item.comment_uin);
                        goToFeedsReviewsDetail(
                          history,
                          item,
                          gameInfo?.edition_unified_id
                            ? { language, gameid: gameInfo?.edition_unified_id }
                            : { language },
                          jumpType,
                        );
                      }}
                      buriedBtnPointId={'TPTV_GoToUrl'}
                    ></FigureCard>
                  </div>
                ))}
            </div>
          </>
        ) : (
          <div className="trend-video-table">
            <TableCommonHook
              recordKey={'comment_uin'}
              records={data?.list || []}
              total={data?.total || 0}
              columns={columns}
              sortColumns={sortColumns}
              hasPageable={false}
              defaultSort={sortBy}
              sortInfo={[sortBy, setSortBy]}
              logBtnId={'TrendingVideos'}
            />
          </div>
        )}
        {/* 点击切换展示更多 */}
        {hasMore && (
          <div className="dbo-switch-show" onClick={handleClick}>
            {isActive ? (
              <>
                <span>{formatMessage({ id: 'Close-1' })}</span>
                <SvgIcon type="arrow-up" />
              </>
            ) : (
              <>
                <span>{formatMessage({ id: 'More' })}</span>
                <SvgIcon type="arrow-down" />
              </>
            )}
          </div>
        )}
      </div>
    </CardCommon>
  );
}
